import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { HorizontalTabNav } from 'components/common/horizontalTabNav';
import { ADMIN_ROUTES } from 'constants/routes';

export const TabNav = React.memo(() => {
  const { pathname } = useLocation();
  // const { hasAccess } = useAccessControl();

  const navigationItems = useMemo(() => {
    const items = [
      {
        path: ADMIN_ROUTES.dashboardList,
        label: 'Dashboard',
        // permission: PERMISSIONS.dashboard.tabs.dashboard.read,
        id: '1',
      },
      {
        path: ADMIN_ROUTES.dashboardNotification,
        label: 'Notifications',
        // permission: PERMISSIONS.dashboard.tabs.notification.read,
        id: '2',
      },
    ];

    // return items.filter((i) => !i.permission || hasAccess(i.permission));
    return items;
  }, []);

  return <HorizontalTabNav pathname={pathname} navigationItems={navigationItems} useCustomOutlet={true} />;
});
